<template>
    <div class="w-full">
        <p class="text-gray-800 text-sm">{{ $t("incidents.forms.affected_projects.title") }}</p>
        <div class="w-full">
            <label for="search" class="sr-only">{{ $t("incidents.forms.affected_projects.search") }}</label>
            <div class="relative w-full">
                <div class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
                    <fa-icon icon="search" class="text-base text-gray-400"></fa-icon>
                </div>
                <input
                    id="search"
                    v-model="searchInput"
                    name="search"
                    class="
                        block
                        w-full
                        bg-white
                        rounded
                        py-2
                        pl-10
                        pr-3
                        text-sm
                        focus:ring-0
                        border-gray-300
                        focus:text-gray-900
                        sm:text-sm
                    "
                    :placeholder="$t('incidents.forms.affected_projects.search')"
                    type="search"
                />
            </div>
        </div>
        <div class="w-full mt-2 flex flex-col max-h-64 h-64 overflow-y-scroll">
            <div class="">
                <div v-if="searchInput">
                    <p class="text-sm text-gray-800 mx-2">
                        {{ $t("incidents.forms.affected_projects.results", { results: projectsList.length }) }}
                    </p>
                </div>
                <div
                    v-for="project in projectsList"
                    :key="project.id"
                    class="text-sm my-1 p-4 rounded cursor-pointer"
                    :class="
                        selectedProjects.includes(project.id)
                            ? 'bg-lightblue-200 hover:bg-lightblue-300'
                            : 'bg-gray-100 hover:bg-gray-200'
                    "
                    @click="onProjectClick(project.id)"
                >
                    <p class="text-lg text-gray-900">
                        {{ project.name }}
                    </p>
                    <a
                        class="text-lightblue-700 hover:text-lightblue-500"
                        :href="project.website_url"
                        :title="project.name"
                        target="_blank"
                    >
                        {{ project.website_url }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FaIcon from "@/Components/FaIcon";
import { computed, ref } from "vue";

export default {
    name: "AffectedProjectSelector",
    components: {
        FaIcon,
    },
    props: {
        allProjects: {
            type: Array,
            required: true,
        },
        affectedProjects: {
            type: Array,
            required: false,
        },
    },
    emits: ["affected-projects"],
    setup(props, { emit }) {
        const searchInput = ref(null);
        const selectedProjects = ref([]);

        if (props.affectedProjects) {
            // eslint-disable-next-line vue/no-setup-props-destructure
            selectedProjects.value = props.affectedProjects;
        }

        const projectsList = computed(() => {
            if (!searchInput.value) return props.allProjects;

            return props.allProjects.filter(
                (project) => project.name.includes(searchInput.value) || project.website_url.includes(searchInput.value)
            );
        });

        const onProjectClick = (projectId) => {
            if (!selectedProjects.value.includes(projectId)) {
                selectedProjects.value.push(projectId);
            } else {
                const index = selectedProjects.value.indexOf(projectId);

                if (index > -1) {
                    selectedProjects.value.splice(index, 1);
                }
            }

            emit("affected-projects", selectedProjects.value);
        };

        return {
            searchInput,
            selectedProjects,
            projectsList,
            onProjectClick,
        };
    },
};
</script>
